var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isProductUnavailable)?_c('Content',[_c('span',[_vm._v("Produto "),_c('strong',[_vm._v("Indisponível")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }